import { ArrowUpRight, BookOpen, Images, Heart } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="we-seccion" aria-label={seccion.titulo}>
      <div className="we-seccion-interior">
        <EncabezadoSeccion etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="we-titulo-enlaces" />
        <Reveal>
          <div className="we-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="we-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`we-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "we-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "we-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="we-seccion" aria-label={seccion.titulo}>
      <div className="we-seccion-interior">
        <EncabezadoSeccion etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="we-titulo-accesos" />
        <Reveal>
          <div className="we-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="we-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={1.5} />
                <span>
                  <span className="we-acceso-titulo">{item.datos.titulo}</span>
                  <span className="we-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { pareja, evento, legal } = datos;

  return (
    <>
      <Marquee
        textos={[
          `${pareja.nombre1} & ${pareja.nombre2}`,
          evento.fechaCorta,
          evento.ciudad,
        ]}
      />
      <section className="we-seccion we-cierre" data-testid="we-cierre">
        <div className="we-seccion-interior">
          <Reveal>
            <Heart className="we-cierre-corazon" strokeWidth={1.5} />
            <p className="we-cierre-mensaje">{pareja.mensajeCierre}</p>
            <p className="we-cierre-nombres">
              {pareja.nombre1} & {pareja.nombre2}
            </p>
            <div className="we-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="we-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="we-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
